if (!window.mediastation) {
    const Cookies = window.Cookies;
    const discountCode = Cookies.get('discount_code');
    const $ = window.$;
    
    if (discountCode && !window.location.pathname.includes('/cart')) {
        const saleBarCode = document.querySelector('#sale-bar-vars') ? JSON.parse(document.querySelector('#sale-bar-vars').innerHTML).code.toUpperCase() : undefined;
        
        if ((discountCode.toUpperCase() != saleBarCode)) {
            class DiscountFlag extends HTMLElement {
                constructor() {
                    super();
                    const locales = window.locales.custom.discount_flag;
                    this.innerHTML = `<div>${locales.code}:</div><strong class="text-uppercase">${discountCode}</strong><div>${locales.active}</div>`;
                    this.generateCloseButton();
                }
    
                generateCloseButton() {
                    const closeButton = document.createElement('div');
                    const navTopIconClose = document.querySelector('#nav-top .icon-close');
                    if (!navTopIconClose) return;
    
                    const iconSVG = navTopIconClose.cloneNode(true);
    
                    closeButton.classList.add('close');
                    closeButton.appendChild(iconSVG);
                    closeButton.addEventListener('click', this.remove.bind(this));
    
                    this.appendChild(closeButton);
                }
    
                setSupportButtonMargin(margin) {
                    if (!margin) return;
                    $('body').append(`<style>
                    @media only screen and (max-width: 767px) {
                        #launcher { 
                            margin-bottom: ${margin}px !important; 
                        }
                    }
                </style>`);
                }
            }
    
            customElements.define('discount-flag', DiscountFlag);
            const discountFlag = new DiscountFlag();
    
            window.discountFlag = true;
            document.querySelector('body').prepend(discountFlag);
            discountFlag.setSupportButtonMargin(discountFlag.offsetHeight);
        }
    }    
}